import axios, { AUTH_PREFIX } from 'src/clients/axios';
import { PaymentInfoResponse, UpdateBankAccountParams } from 'src/models';
import { PaymentInfoGetRsData } from 'src/models/Client';

export const updatePaymentInfo = (data: UpdateBankAccountParams) => {
  return axios.request<PaymentInfoResponse>({
    url: `${AUTH_PREFIX}/account/payment-info`,
    method: 'post',
    data,
  });
};
/**
 * Get Account Information Including Account Upgrade Submission Etc
 * @param {*} get
 */

export const getPaymentInfo = () => {
  return axios.get<PaymentInfoGetRsData>(`${AUTH_PREFIX}/account/payment-info`);
};
